import { combineReducers } from '@reduxjs/toolkit';
import filters from './filters/root';

const root = combineReducers({
  filters,
});

export type RegisterLimitStateProps = ReturnType<typeof root>['filters'];

export default root;
